import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate, dvUpdate, dvDelete } from '../api/dataverseClient';

export interface ProjectDependency {
  dagrun_pm_projectdependencyid: string;
  dagrun_pm_name: string;
  dagrun_pm_predecessorprojectid?: string | null;
  dagrun_pm_predecessormilestoneid?: string | null;
  dagrun_pm_successorprojectid?: string | null;
  dagrun_pm_successormilestoneid?: string | null;
  dagrun_pm_lagdays?: number | null;
  dagrun_pm_dependencytype?: number | null;
  dagrun_pm_slipdetected?: boolean | null;
}

export const ProjectDependencyType = {
  FinishToStart:   1,
  StartToStart:    2,
  FinishToFinish:  3,
} as const;

const FIELDS = [
  'dagrun_pm_projectdependencyid', 'dagrun_pm_name',
  'dagrun_pm_predecessorprojectid', 'dagrun_pm_predecessormilestoneid',
  'dagrun_pm_successorprojectid',   'dagrun_pm_successormilestoneid',
  'dagrun_pm_lagdays', 'dagrun_pm_dependencytype', 'dagrun_pm_slipdetected',
];

export async function listAllProjectDependencies(pca: IPublicClientApplication): Promise<ProjectDependency[]> {
  return dvList<ProjectDependency>(pca, 'dagrun_pm_projectdependencys', {
    select: FIELDS,
    top: 1000,
  });
}

export interface CreateProjectDependencyInput {
  name: string;
  predecessorProjectId: string;
  predecessorMilestoneId: string;
  successorProjectId: string;
  successorMilestoneId: string;
  lagDays?: number;
  dependencyType?: number;
  slipDetected?: boolean;
}

export async function createProjectDependency(pca: IPublicClientApplication, input: CreateProjectDependencyInput): Promise<string> {
  return dvCreate(pca, 'dagrun_pm_projectdependencys', {
    dagrun_pm_name: input.name,
    dagrun_pm_predecessorprojectid: input.predecessorProjectId,
    dagrun_pm_predecessormilestoneid: input.predecessorMilestoneId,
    dagrun_pm_successorprojectid: input.successorProjectId,
    dagrun_pm_successormilestoneid: input.successorMilestoneId,
    dagrun_pm_lagdays: input.lagDays ?? 0,
    dagrun_pm_dependencytype: input.dependencyType ?? ProjectDependencyType.FinishToStart,
    dagrun_pm_slipdetected: input.slipDetected ?? false,
  });
}

export async function updateProjectDependency(pca: IPublicClientApplication, id: string, patch: Record<string, unknown>): Promise<void> {
  return dvUpdate(pca, 'dagrun_pm_projectdependencys', id, patch);
}

export async function deleteProjectDependency(pca: IPublicClientApplication, id: string): Promise<void> {
  return dvDelete(pca, 'dagrun_pm_projectdependencys', id);
}
